const SnakeGame = require('./snake.js');
const SnakeView = require('./snake-view.js');

$l( () => {
  const rootEl = $l('.snake');
  const game = new SnakeGame();
  new SnakeView(game, rootEl);
});



//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = 0
// module chunks = 0